import React, { useCallback } from 'react';
import { trackEvent } from 'helpers';
import styles from './styles/Button.module.scss';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';

export interface IProps {
  className?: string;
  disabled?: boolean;
  id?: string;
  inverted?: boolean;
  children?: React.ReactNode;
  link?: string;
  externalLink?: string;
  text?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  eventName?: string;
  eventData?: any;
  loading?: boolean;
  onClick?: (e?: any) => void;
}

const Button = ({
  className,
  disabled,
  children,
  eventName,
  eventData = {},
  id,
  inverted,
  link,
  externalLink,
  text,
  type,
  loading,
  onClick,
}: IProps) => {
  const handleClick = useCallback(
    (e) => {
      if (eventName) {
        trackEvent(eventName, eventData);
      }
      if (onClick) {
        onClick(e);
      }
    },
    [eventName, eventData, onClick],
  );

  if (externalLink) {
    return (
      <a
        id={id}
        className={classnames(
          styles.link,
          inverted && styles.inverted,
          className,
        )}
        href={externalLink}
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text || children}
      </a>
    );
  }

  if (link) {
    return (
      <Link
        id={id}
        className={classnames(
          styles.link,
          inverted && styles.inverted,
          className,
        )}
        to={link}
        onClick={handleClick}
      >
        {text || children}
      </Link>
    );
  }

  return (
    <button
      id={id}
      disabled={disabled}
      className={classnames(
        styles.button,
        inverted && styles.inverted,
        className,
      )}
      onClick={handleClick}
      type={type}
    >
      {text || children}
      {loading && <Loader active={loading} size="tiny" inline inverted />}
    </button>
  );
};

export default Button;
